import { Text } from '@bechtel/gds';
import { map } from 'lodash';
import { FC, Fragment } from 'react';
import MatrixItem from './item';
import {
  HeaderContainerStlyed,
  HeaderStyled,
  MatrixContainerStyled,
  TableHeaderStickyStyled,
  TableRowHeaderStyled,
  TableStyled,
} from './styled';
import { PermissionMatrixProps } from './types';
export const PermissionMatrix: FC<PermissionMatrixProps> = ({
  selectedRoles,
  rolePermissionScopeList,
  onPermissionSelect,
  moduleList,
  collapseModules,
  onExpandCollapseModule,
  lstRefrence,
  lstItemRefrence,
}) => {
  return (
    <MatrixContainerStyled ref={lstRefrence}>
      <TableStyled>
        <thead>
          <TableRowHeaderStyled>
            <TableHeaderStickyStyled>
              <HeaderContainerStlyed>
                <HeaderStyled style={{ width: '321px' }} justifyContent={{ sm: 'flex-end' }} pr={{ sm: '550' }}>
                  &nbsp;
                </HeaderStyled>
                {map(selectedRoles, (item) => {
                  return (
                    <HeaderStyled
                      style={{ width: '170px', zIndex: '222' }}
                      justifyContent={{ sm: 'center' }}
                      key={item.id}
                    >
                      <Text size="300" color="black">
                        {item.description}
                      </Text>
                    </HeaderStyled>
                  );
                })}
              </HeaderContainerStlyed>
            </TableHeaderStickyStyled>
          </TableRowHeaderStyled>
        </thead>
        <tbody>
          <Fragment>
            {map(moduleList, (moduleItem, moduleIndex) => {
              return (
                <MatrixItem
                  lstItemRefrence={lstItemRefrence}
                  moduleIndex={moduleIndex}
                  moduleItem={moduleItem}
                  selectedRoles={selectedRoles}
                  key={moduleItem.moduleId}
                  rolePermissionScopeList={rolePermissionScopeList}
                  onPermissionSelect={onPermissionSelect}
                  collapseModules={collapseModules}
                  onExpandCollapseModule={onExpandCollapseModule}
                />
              );
            })}
          </Fragment>
        </tbody>
      </TableStyled>
    </MatrixContainerStyled>
  );
};
